<template>
  <div class="crudblock">
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      :page.sync="page"
      :search.sync="query"
      v-model="form"
      :before-open="beforeOpenScope"
      @on-load="onLoad"
      @search-change="searchChange"
      @search-reset="searchReset"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @sort-change="sortChange"
      @selection-change="selectionChange"
    >
      <template slot-scope="{ row }" slot="name">
        <div class="project-name" @click="handleDetail(row)">{{row.name}}</div>
      </template>
      <template slot-scope="scope" slot="expireQuota"> 
            <div>
              {{getMoney(scope.row.expireQuota)}}
            </div>
      </template>
      <template slot-scope="scope" slot="quota"> 
            <div>
              {{getMoney(scope.row.quota)}}
            </div>
      </template>
      <template slot-scope="scope" slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.project_add"
          @click.stop="handleApproval(scope.row)"
          >项目立项
        </el-button>
        <!-- 2022/09/01 转贷项目管理改造 -->
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.project_add"
          @click.stop="showMultipleSubmit"
          >批量提交
        </el-button>
        <el-button
          type="primary"
          plain
          size="small"
          icon="el-icon-edit"
          v-if="permission.project_edit"
          @click.stop="handleEdit"
          >编辑
        </el-button>
        <el-button
          type="danger"
          plain
          size="small"
          v-if="userInfo.role_name == 'administrator' || permission.project_delete"
          icon="el-icon-delete-solid"
          @click.stop="handleDel"
          >删除
        </el-button>

        <el-button
            size="small"
            plain
            @click="exportShow"
            icon="el-icon-download"
            >导出数据</el-button
          >
      </template>

      <template slot="menuRight">
        <el-tooltip
              class="item"
              effect="dark"
              content="显隐"
              placement="top"
            >
              <el-button
                icon="el-icon-s-operation"
                circle
                @click="operation"
              ></el-button>
            </el-tooltip>
      </template>
      <template slot="searchMenu" slot-scope="{ row }">
        <el-button type="primary" @click="save(row)">保存</el-button>
        <el-button  type="primary"  @click="screen"
          ><a-icon type="filter" /> 高级筛选</el-button
        >
      </template>
      
    </avue-crud>
    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="option"
              ref="formScreen"
              v-model="form"
              @submit="handleSearch"
              @reset-change="searchResetScreen"
            >
              <template slot="expireQuotaSlot">
                <div class="form_slot">
                  <el-input-number
                    v-model="form.expireQuotaMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="form.expireQuotaMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
              <template slot="quotaSlot">
                <div class="form_slot">
                  <el-input-number
                    v-model="form.quotaMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="form.quotaMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>
    
    <!-- 批量提交 -->
    <el-dialog
      title='批量提交审批'
      :visible.sync="dialogVisible"
      width= "70%"
    >
      <DialogTable 
        ref="dialogTable"
        @goNext="goNext"
        @cancelDialog="cancelDialog"      
      />
    </el-dialog>

    <el-dialog
      title= '批量提交审批'
      :visible.sync="formVisible"
    >
      <avue-form
          :option="submitConfig"
          ref="formScreen"
          v-model="dialogForm"
          @submit="filterSearch"
          @reset-change="searchReset"
      >
        <template slot="submitListLabel">
          已选择<span style="color: #409EFF;font-weight: 700;">{{submitList.length}}个</span>项目:
        </template>
        <template slot="submitList">
          <div class="list-container">
            <div class="init-block">
              <template v-for="(item, index) in submitList">
                <p :key="index">{{item.name}}</p>
              </template>
            </div>
          </div>
        </template>
      </avue-form>
      <div class="bottom-line">
          <el-button plain @click="formVisible = false" size="small">取消</el-button>
          <el-button type="primary" @click="submitForm" size="small">确定</el-button>
      </div>
    </el-dialog>

    <ExportData ref="exportData" @exportDownload="exportDownload" />
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="false"
      :clear="false"
      @setPeople="setPeople"
    />
    <Options
          ref="Options"
          :plainOptions="optionColumn"
          :pageDataId="this.$route.path"
          @returnData="returnData"
        />
  </div>
</template>

<script>
import * as api from "@/api/zd/project";
import { mapGetters } from "vuex";
import { downLoadTemplate } from "@/router/downLoadTem";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import Options from "@/components/ShowHidden/showhidden";
import DialogTable from "./dialogTable"
import workFlow from "@/mixins/workFlow";
export default {
  name: "projectManage",
  mixins: [workFlow],
  data() {
    return {
      processKey: 'process_zd_project_manage',
      detailFormUrl: '/zd/project/flows',
      formVisible: false,
      dialogVisible: false,
      drawer: false,
      shlb: 0,
      form: {},
      dialogForm: {},
      formScreen: {},
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      query: {},
      data: [],
      selectionList: [],
      optionColumn: [],
      option: {
        // excelBtn: true,
        menu: false,
        align: "center",
        card: true,
        columnBtn: false,
        searchBtn: true,
        refreshBtn:false,
        tip: false,
        lazy: true,
        simplePage: true,
        searchMenuSpan: 6,
        tree: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        labelWidth: 100,
        selection: true,
        selectionWidth: 45,
        searchShow: false,
        column: [
          {
            label: "搜索查询",
            searchPlaceholder: "项目编号/项目名称/客户名称",
            placeholder: "项目编号/项目名称/客户名称",
            prop: "search",
            hide: true,
            display: true,
            search: true,
            hideshow:true,
          },
        
          {
            label: "贷款到期金额",
            prop: "expireQuotaSlot",
            formslot: true,
            hide: true,
            display: true,
            hideshow:true,
          },
          {
            label: "申请转贷金额",
            prop: "quotaSlot",
            formslot: true,
            hide: true,
            display: true,
            hideshow:true,
          },
          {
            sortable: "custom",
            label: "项目编号",
            prop: "number",
            fixed: true,
            filterable: false,
            display: false,
            width:120
          },
          {
            label: "项目名称",
            prop: "name",
            fixed: true,
            display: false,
            width:240,
            slot: true,
            overHidden: true
          },{
            label: "客户名称",
            prop: "custId",
            type: "select",
            filterable:'true' ,
            dicUrl: "/api/blade-/zd/custom/getListDefault",
            dicMethod: "post",
            dicQuery: {},
            props: {
              label: "custName",
              value: "id",
            },
            dataType: "string",
            display: true,
            width:200,
          },
          {
            label: "申请银行",
            prop: "bankName",
            display: false,
              width:150,

          },
          {
            label: "申请银行",
            prop: "bankId",
            type: "select",
            filterable:'true' ,
            dicData: [],
            dataType: "string",
            search: true,
            hide: true,
            display: true,
            hideshow:true
          },
          {
            sortable: "custom",
            label: "贷款到期金额",
            prop: "expireQuota",
            display: false,
            slot: true,
            width:120
          },
          {
            sortable: "custom",
            // sortable: true,
            label: "申请转贷金额",
            prop: "quota",
            display: false,
            slot: true,
            width:120
          },
          {
            label: "使用费率",
            prop: "loanRate",
            type: "select",
            dicUrl: "/api/blade-/zd/interestrate/dictionary",
            dicMethod: "get",
            dicQuery: {},
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            display: true,
            formatter: (row, value, label, column) => {
              
              if (value == -1) {
                return "-";
              } else {
                 return label
              }
            }
          },
          {
            label: "客户经理",
            prop: "managerName",
            display: false,
          
          },
          {
            label: "客户经理",
            prop: "managerUserName",
            readonly: true,
            clearable:false,
            display: true,
            hide: true,
            hideshow:true,
            click: () => {
              this.selectPersonClick();
            },
          },
          {
            label: "审批状态",
            prop: "auditStatus",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=project_build_state",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            search: true,
          }
        ],
      },
      submitList: [],
      submitConfig: {
        labelWidth: 140,
        backgroundColor: '#f7f9fe',
        align: 'center',
        submitBtn: false,
        emptyBtn: false,
        menuBtn: false,
        menu:false,
        column: [
            {
                label: '已选择项目',
                prop: 'submitList',
                type: 'textarea',
                disabled: true,
                labelslot: true,
                formslot: true,
                span: 24,
                rules: [
                    {
                        required: true,
                        message: '',
                        trigger: "blur"
                    }
                ]
            },{
              label: '备注',
              span: 20,
              prop: 'remark',
              type: 'textarea'
            }
        ]       
      }
    };
  },
 
  computed: {
    ...mapGetters(["permission", 'userInfo']),
  },
  watch: {
    files: {
      handler(newName, oldName) {
        if (oldName != undefined) {
          this.cloudTages(newName);
        }
      },

      immediate: true,
    },
  },
  props: ["files"],
  components: {
    TagsCloud,
    Options,
    SelectPerson,
    ExportData,
    DialogTable
  },
  async created() {
    this.getListDefault();
    // 获取流程定义ID
    // this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
    this.getBasicConfigData()
    this.optionColumn = this.deepClone(this.option.column)
  },
  activated() {
    this.onLoad(this.page)
  },
  methods: {
    async submitForm() {
      let redirectInfo ={
        url: this.detailFormUrl,
        id: ''
      }      
      let flowParams = {
        detailFormUrl: '',
        processId: this.processDefinedId,
        comment: '',
        attachmentList: [],
        remark: this.dialogForm.remark,
        processInstanceName: ''
      }
      let processInsId = await this.startWorkFlowProcess(flowParams)
      let array = []
      let nameArray = []
      this.submitList.map(item => {
        array.push(item.id)
        nameArray.push(item.name)
      })
      redirectInfo.id = processInsId
      // 发起转贷项目审批流程
      let redirectInfos ={
          url: '/zd/project/flows',
          id: processInsId
      }      
      let params = {
        detailFormUrl: JSON.stringify(redirectInfos),
        flowableId: processInsId,
        batchIds: array,
        batchNames: nameArray,
        fileMenuName: this.uploadPermissionNameTwo,
        fileMenuUrlName: this.uploadPermissionNameOne,
        remark: this.dialogForm.remark
      }
      let res = await api.submitBatch(params)
      if(res.data.code == 200) {
        this.formVisible = false
        // 跳转批量审批详情
        this.$router.push({
          path: `${this.detailFormUrl}/${processInsId}`
        })
      }
    },

    goNext(list) {
      this.submitList = list
      this.dialogVisible = false
      this.formVisible = true
    },

    cancelDialog() {
      this.dialogVisible = false
    },
    showMultipleSubmit() {
      if(this.$refs.dialogTable) {
        this.$refs.dialogTable.queryList()
      }
      this.dialogVisible = true
    },

    selectionChange(file) {
      this.selectionList = file
    },
     //显隐
     operation() {
      let origencolum = this.option.column;
      this.$refs.Options.showmode();
    },
    returnData(data) {
      this.option.column = data;
    },
    onLoad() {
      api
        .getListProject({
          firstNum: (this.page.currentPage - 1) * this.page.pageSize,
          num: this.page.pageSize,
          ...this.query,
        })
        .then((res) => {
          this.auditlistNub = res.data.data.shlb;
          this.page.total = res.data.data.total;
          this.data = res.data.data.list;
        })
        .catch((res) => {
          
        });
    },
    //申请银行列表
    getListDefault() {
      api.getListDefault({}).then((res) => {
        const column = this.findObject(this.option.column, "bankId");
        column.dicData = res.data.data.map((item) => {
          return {
            label: item.bankName,
            value: item.id,
          };
        });
      });
    },
    //新增
    rowSave(row, done, loading) {
      api.submitCustom(row).then(
        (res) => {
          // 获取新增数据的相关字段
          const data = res.data.data;

          this.$message({
            type: "success",
            message: "操作成功!",
          });
          // 数据回调进行刷新
          done(row);
        },
        (error) => {
          
          loading();
        }
      );
    },
    //修改
    rowUpdate(row, index, done, loading) {
      let data = {
        custType: row.custType,
        custName: row.custName,
        idcard: row.custType == 1 ? row.idcard : "",
        unifiedSocialCreditCode:
          row.custType == 2 ? row.unifiedSocialCreditCode : "",
        businessManagerId: row.businessManagerId,
        businessManage: row.businessManage,
        id: row.id,
      };
      api.submitCustom(data).then(
        () => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          // 数据回调进行刷新
          done(row);
        },
        (error) => {
          
          loading();
        }
      );
    },

    beforeOpenScope(done, type) {
      if (["add"].includes(type)) {
        api.getUsers({ type: 1 }).then((res) => {
          this.form.custType = 1;
          this.form.businessManage = res.data.data[0].id;
        });
      }
      // if (["edit", "view"].includes(type)) {
      // }
      done();
    },

    //导出
    handleExport() {
      // this.$confirm("是否导出拜访数据?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {
      //   window.open(
      //     `/api/zd/visit/export?${
      //       this.website.tokenHeader
      //     }=${getToken()}&account=${this.search.account}&realName=${
      //       this.search.realName
      //     }`
      //   );
      // });
    },
    //排序
    sortChange(val) {
      this.query.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";

      this.query.orderName = val.prop;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    //搜索
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    searchReset() {
      this.query = {};
      this.drawer = false;
      this.onLoad(this.page);
    },
    //高级筛选清空
    searchResetScreen(){
      this.$refs.crud.searchReset()
    },
    save(row) {
      this.$emit("rowdata", row);
    },
    cloudTages(data) {
      
      this.form = data;
      
      this.searchChange(data);
    },

    //显示高级筛选抽屉
    screen() {
      this.form = { ...this.form, ...this.query };
      this.drawer = true;
    },
    //高级筛选
    handleSearch(form, done, loading) {
      this.query = { ...this.query, ...form };
      this.drawer = false;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },

    //立项
    handleApproval() {
      // this.$refs.crud.rowAdd();
      this.$router.push({ path: `/zd/project/approval/-1` });
    },
    //编辑
    handleEdit() {
      if(this.selectionList.length > 1){
        this.$message.error('只能选择一条数据进行编辑')
      }else if(this.selectionList.length == 1){
        let data = this.selectionList[0]
        // 判断有无编辑权限
        if(this.permission.project_edit) {
          if(data.auditStatus != 0){
            this.$message.error('该条数据无法编辑')
          }else {
            this.$router.push({
              path: `/zd/project/approval/${data.id}`,
            })
          }
        }else {
          this.$message.error('您暂无编辑权限')
        }
      }else{
        this.$message.error('请选择一条数据进行编辑')
      }
    },
    //详情
    handleDetail(row) {
      this.$router.push({ path: `/zd/project/detail/${row.id}` });
    },
    //删除
    async handleDel() {
      let self = this,
          flowData='',
          presentFlow = ''
      if(this.selectionList.length == 1){
        let data = this.selectionList[0]
        if(data.auditStatus != 0) {
          // 查询审批数据
          let processDetail = await self.queryTaskDetail(data.flowableId)
          flowData = processDetail.flowData
          presentFlow = flowData[flowData.length - 1]
          
        }
        if(this.permission.project_delete || this.userInfo.role_name.includes('admin')) {
          let isFirstFlowPermission = flowData[0].assignee == self.userInfo.user_id && flowData[0].historyActivityId == presentFlow.historyActivityId
          // if( data.auditStatus == 0 || isFirstFlowPermission){
            this.$confirm('确定删除选择的数据?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              self.deleteData()
            }).catch(() => {
              self.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
          // } else {
          //   this.$message.error('该条数据处于审批状态无法删除')
          // }
        }else {
          this.$message.error('您没有权限删除此条数据')
        }
      }else{
        this.$message.error('请选择一条数据进行删除')
      }
    },

    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData() {
      let ids = this.selectionList.map((item) => {
        return item.id
      })
      let res = await api.deleteProject({ id: ids.join(',') });
      if(res.data.code == 200){
        this.$message.success('删除成功')
        // 刷新列表
        this.onLoad()
      }
    },
    
    //获取 人员名称
    getVisitPeople() {
      let people = this.checkUserList.map((item) => {
        return item.realName;
      });
      let ids = this.checkUserList.map((item) => {
        return item.id;
      });
      this.$nextTick(() => {
        this.form.managerUserName = people.join(",");
        this.form.managerUserIds = ids.join(",");
      });
    },
    // 人员选择插件打开
    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    //人员 获取
    setPeople(val) {
      this.checkUserList = val;
      this.getVisitPeople();
    },
    exportShow() {
      this.$refs.exportData.showModel();
    },
    exportDownload(value) {
      let page=this.page
      let data = {
        export:value.code
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.query,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.query,
        };
      }
      downLoadTemplate("/api/zd/project/export", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.projectManage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .crudblock {
    background: #ffff;
    padding:16px;
    border-radius: 4px;
    .project-name{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #409EFF;
    }
    .project-name:hover{
      color: #409EFF;
      cursor: pointer;
    }
  }
}
.init-block {
    background-color: #f9f9f9;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(228, 228, 228);
    border-radius: 5px;
    padding: 10px 15px;
    width: 80%;
    p{
      line-height: 22px;
      margin-bottom: 0;
    }
}
.bottom-line{
    width: 100%;
    border-top: 1px solid #f0f0f0;
    /* float: right; */
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
.input_width {
  width: 220px;
}
/deep/ .el-dialog__header {
    border-radius: 5px 5px 0px 0px;
    background-color: rgb(245, 245, 245);
    color: #333;
}
/deep/ .el-dialog__body {
    padding: 10px 20px 20px !important;
}
</style>

